import axios from "axios";
import { API_URL } from "./index";

class CompanyService {
    getCompanyByID = (id) => {
        const url = API_URL.companyRelease(id);
        return axios.get(url, {
            params: {
                loadAllContacts: true,
            },
        });
    };

    saveCompany = (company) => {
        const url = API_URL.companyRelease();
        return axios.post(url, company).then((response) => response.data);
    };

    editCompany = (company) => {
        const url = API_URL.companyRelease();
        return axios.put(url, company).then((response) => response.data);
    };

    removeCompany = (id) => {
        const url = API_URL.companyRelease(id);
        return axios.delete(url).then((response) => response.data);
    };
}

export default new CompanyService();
